export default __webpack_public_path__ + "static/media/purple-horizontal-bars.27ae1857.svg";